import React from 'react'
import { Form } from 'react-bootstrap'
import Select from 'react-select'

export default function SingleSelect(props) {

    const { label_name, placeholder, disabled, closeMenu, option, name, defaultValue, onChange, onBlur, error, loading, reference } = props

    return (
        <>
            <Form.Group className="mb-3" controlId="">
                {label_name == '' ? '' : <Form.Label className='form_label'>{label_name}</Form.Label>}
                <Select
                    ref={reference}
                    closeMenuOnSelect={closeMenu}
                    placeholder={placeholder}
                    isDisabled={disabled}
                    options={option}
                    className='config_filed_select'
                    classNamePrefix="select"
                    name={name}
                    defaultValue={defaultValue}
                    onChange={onChange}
                    onBlur={onBlur}
                    isLoading={loading}
                />
                {error}
            </Form.Group>
        </>
    )
}
